import { Link } from "react-router-dom";
import { HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS } from "../data/site";
import { Reveal } from "../components/Reveal";

const FAQ = () => (
  <div data-testid="page-faq" className="bg-background">
    <section className="border-b border-border">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 lg:py-20">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-12 bg-[#C8102E]" />
            <span className="text-xs uppercase tracking-overline font-bold text-muted-foreground">
              Frequently Asked Questions
            </span>
          </div>
          <h1 className="font-display font-black uppercase text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.95] max-w-3xl">
            Answers before <br />
            <span className="text-[#C8102E]">you ask.</span>
          </h1>
        </Reveal>
      </div>
    </section>

    <section className="py-16 lg:py-20">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-border"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display font-semibold text-base md:text-lg py-6 hover:no-underline hover:text-[#C8102E] [&[data-state=open]]:text-[#C8102E]">
                  <span className="flex items-start gap-4">
                    <span className="text-[#C8102E] font-mono text-xs mt-1">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-muted-foreground leading-relaxed pb-6 pl-8">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14 border border-border bg-card p-8 flex flex-col md:flex-row items-start md:items-center gap-6 justify-between">
            <div className="flex items-start gap-4">
              <HelpCircle className="h-8 w-8 text-[#C8102E] shrink-0" />
              <div>
                <h3 className="font-display font-bold text-xl">
                  Still have a question?
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                  Our team is happy to help you find the exact part you need.
                </p>
              </div>
            </div>
            <Link
              to="/contact"
              className="inline-flex items-center h-11 px-5 bg-[#C8102E] text-white text-xs font-bold uppercase tracking-overline hover:bg-[#A00D24] transition-colors duration-200"
              data-testid="faq-cta-contact"
            >
              Ask Us
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  </div>
);

export default FAQ;
